import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {setUuid} from "@arboxappv4/shared/src/redux/siteSlice";
import uuid from 'react-uuid';
import {apiAction} from "@arboxappv4/shared/src/helpers/HTTP";
import {onLinkClicked} from "../functions";
import {useNavigate} from "react-router-dom";

const useOneTimeLink = (props) => {
    const { linkUUID } = props;
    const userUUID = useSelector(state => state.site.uuid)
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        if(!userUUID) {
            dispatch(setUuid(uuid()))
        }
    }, [userUUID]);

    useEffect(() => {
        if(linkUUID && userUUID) {
            validateOneTimeLink()
        }
    }, [linkUUID, userUUID]);

    const validateOneTimeLink = async () => {
        try {
            await apiAction('validateOneTimeLink', 'post', {linkUUID, userUUID});
        } catch(error) {
            onLinkClicked('/404', navigate)
        }
    }

};

export default useOneTimeLink;